<template>
  <div>
    <h1>Génération automatique déclaratif RFA</h1>
    Année :
    <div class="d-flex mb-3">
      <label class="d-block">
        <input type="radio" :value="new Date().getFullYear() - 1" v-model="selectedYear" />
        {{new Date().getFullYear() - 1}}
      </label>
      <label class="d-block ms-3">
        <input type="radio" :value="new Date().getFullYear()" v-model="selectedYear" />
        {{new Date().getFullYear()}}
      </label>
    </div>
    Période :
    <div class="d-flex mb-3">
      <label class="d-block">
        <input type="radio" value="A" v-model="selectedPeriod" />
        Annuel
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="T1" v-model="selectedPeriod" />
        T1
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="T2" v-model="selectedPeriod" />
        T2
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="T3" v-model="selectedPeriod" />
        T3
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="S1" v-model="selectedPeriod" />
        S1
      </label>
    </div>
    Pays:
    <div class="d-flex mb-3">
      <label class="d-block">
        <input type="radio" value="FRA" v-model="country" />
        France
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="BEL" v-model="country" />
        Belgique
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="ALL" v-model="country" />
        France/Belgique
      </label>
    </div>
    Filtre:
    <div class="d-flex mb-3">
      <label class="d-block">
        <input type="radio" value="" v-model="selectedFilter" />
        Aucun
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="LNL" v-model="selectedFilter" />
        Ligne et Lumière
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="BYLNL" v-model="selectedFilter" />
        Ligne et Lumière + By Ligne et Lumière
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="WA" v-model="selectedFilter" />
        Wood Alliance
      </label>
    </div>
    Type:
    <div class="d-flex mb-3">
      <label class="d-block">
        <input type="radio" value="" v-model="type" />
        Classique
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="VOL" v-model="type" />
        Volume
      </label>
      <label class="d-block ms-3">
        <input type="radio" value="CO" v-model="type" />
        Complet
      </label>
    </div>
    <button @click="exportXls">Export</button>
  </div>
</template>

<script>
  import { saveAs } from 'file-saver';

  import { generateRfaDeclarationXls } from "@/utils/rfa";

  export default {
    name: "GenerateRfaDeclarationTab",
    data() {
      return {
        selectedYear: new Date().getFullYear(),
        selectedPeriod: "A",
        selectedFilter: "",
        country: "FRA",
        type: "",
      };
    },
    methods: {
      async exportXls() {
        generateRfaDeclarationXls(this.selectedYear,
          this.selectedPeriod,
          this.country,
          this.type,
          this.selectedFilter)
          .then(res => {
            const data = Buffer.from(res);

            const blob = new Blob([data], {
              type: "application/vnd.ms-excel.sheet.macroEnabled.12"
            });
            saveAs(blob, "declaratif rfa.xlsm");
          });
      },
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/RFA/GenerateRfaDeclarationTab.vue